<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/list-food-court">Create Food Court</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">View Food Courts</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">View Food Courts</h2>
        <!-- <button class="btn btn-primary" (click)="addNewFoodCourt()">Add Food Court</button> -->
    </div>

    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">
            <div class="col-12 py-2 py-md-3 d-flex align-items-center">
                <form class="search_form w-100">
                    <svg-icon src="./assets/images/icons/search.svg"></svg-icon>
                    <input type="text" name="searchText" id="menu-search" class="search_field"
                        placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}} Food Court{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2" *ngIf="foodCourtRemove">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedFoodCourt"
                    name="list_name" value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select all</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button ngbDropdownItem (click)="openModalRemoveFoodCourt(onlyFoodCourtIds)">Remove
                        Selected</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let fcourt of newmainFoodCourtList | paginate: { itemsPerPage: 12,
            currentPage: page, totalItems:newmainFoodCourtList?.length }; let i=index">
            <div class="bg-lighter p-3 rounded d-flex align-items-center column-gap-2 h-100">
                <div class="custom-control custom-checkbox flex-shrink-0 mt-1" *ngIf="foodCourtEdit || foodCourtRemove">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="fcourt.isSelected" name="list_name"
                        [id]="fcourt.foodCourtId + 'list_name'" value="{{fcourt.foodCourtId}}"
                        (change)="isAllSelected()">
                    <label [for]="fcourt.foodCourtId + 'list_name'" class="custom-control-label cursor-pointer"></label>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <h3 class="font-weight-bold text-primary h5 mb-0 cursor-pointer"
                        (click)="goToVendorListPage(fcourt.foodCourtId, fcourt.foodCourtName)">
                        {{fcourt.foodCourtName}}</h3>
                    <div ngbDropdown *ngIf="foodCourtEdit">
                        <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown_edit"
                            ngbDropdownToggle>
                            <svg-icon src="../../../assets/images/icons/more_dots.svg"
                                [svgStyle]="{ 'height.px':20 }"></svg-icon>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="download_dropdown_edit">
                            <button ngbDropdownItem (click)="goToEditPage(fcourt.foodCourtId)">Edit Details</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainFoodCourtList?.length > 12">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelFoodCourtList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(mainFoodCourtList?.length)}}</div>
                <!-- <div class="page_numbers">
                    {{paginationCount(mainSurveyList?.length)}}/{{indexPage}}</div> -->
            </div>
        </div>
    </div>
</div>